export function isStr(val: any): boolean {
  return typeof val === 'string';
}

export function toNum(str: string): number | undefined {
  try {
    if (isStr(str)) {
      let num = Number(str);
      if (isNaN(num)) {
        throw new Error(`Argument must be string, ${str}`);
      }
      return num;
    } else {
      throw new Error(`Argument must be string, ${str}`);
    }
  } catch (error) {
    throw error;
  }
}